<template>
  <b-upload
    class="cp-backoffice-upload"
    drag-drop
    accept="image/*"
    @input="uploadImage"
    :loading="loading"
  >
    <section class="section">
      <div v-if="url">
        <b-icon
          v-if="deletable"
          class="cp-backoffice-upload-delete-button"
          pack="far"
          icon="times-circle"
          size="is-medium"
          @click.native.stop.prevent="handleDelete"
        />
        <img class="cp-backoffice-upload-image" :src="url" />
        <p>{{ $t('backoffice.common.reupload.label') }}</p>
      </div>
      <div class="content has-text-centered" v-else>
        <div class="cp-backoffice-upload-icon">
          <b-icon pack="fas" icon="camera" size="is-large"></b-icon>
        </div>
        <p>{{ $t('backoffice.common.upload.label') }}</p>
      </div>
    </section>
  </b-upload>
</template>

<script>
export default {
  name: 'Upload',
  props: {
    url: {
      type: String,
    },
    deletable: {
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    handleDelete() {
      this.$emit('delete-image', this.url);
    },
    async uploadImage(file) {
      this.loading = true;

      try {
        const { url } = await this.$imagekit.upload({
          file,
          fileName: file.name,
        });

        if (this.url) {
          this.$emit('change-image', url);
        } else {
          this.$emit('add-image', url);
        }
      } catch (e) {
        this.$buefy.snackbar.open({
          message: this.$t('quill.cannot.upload.image'),
          type: 'is-danger',
          position: 'is-top',
          actionText: this.$t('snackbar.ok.text'),
          duration: 10000,
        });

        this.$sentry.captureException(e);

        throw e;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cp-backoffice-upload {
  position: relative;

  &-delete-button {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 1;
  }

  &-icon {
    height: 100px;
  }

  &-image {
    height: 100px;
    display: block;
    margin: auto;
  }

  /deep/ .upload-draggable {
    width: 200px;
  }

  /deep/ .upload-draggable::after {
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
  }
}
</style>
